// Copyright (c) 2016 Deere & Company

import ProductInformationContainer from './product-information-container';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    claim: state.claims.mccFollowup.claim,
    formValidation: state.claims.mccFollowup.formValidation,
    goodsInstallationVatOptions: state.claims.goodsInstallationVatOptions,
    isEditable: state.claims.mccFollowup.isEditable,
    methodOfContactOptions: state.claims.mccFollowup.methodOfContactOptions,
    relationshipOptions: state.claims.mccFollowup.relationshipOptions
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ProductInformationContainer);



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/components/product-information/index.js